export interface LandingRouteOption {
    /** Route name, as used in routes.ts / router.push({ name }). */
    name: string;
    /** i18n key for this route's label — reuses the same key its sidenav entry uses. */
    labelKey: string;
}

// Parameter-less, permission-agnostic child routes that are safe as an org-configured landing page.
// labelKey values are taken from config/sidebar/participant.nav.ts's entries for these routes.
export const PARTICIPANT_LANDING_ROUTES: LandingRouteOption[] = [
    { name: 'dashboard', labelKey: 'app.navigation.dashboard' },
    { name: 'courses', labelKey: 'app.navigation.myModules' },
    { name: 'skillProgress', labelKey: 'app.navigation.userReports' },
];

// labelKey values are taken from config/sidebar/admin.nav.ts's entries for these routes.
export const ADMIN_LANDING_ROUTES: LandingRouteOption[] = [
    { name: 'adminDashboard', labelKey: 'app.navigation.adminDashboard' },
    { name: 'coursesManagement', labelKey: 'app.navigation.courses' },
    { name: 'readinessAndSkills', labelKey: 'app.navigation.readinessAndSkills' },
];
